// import moment from "moment";

// AUTHENTICATION :
export const setAuth = (token) => {
  localStorage.setItem("TIMESHEET-TOKEN", token);
};

export const getAuth = () => {
  return localStorage.getItem("TIMESHEET-TOKEN");
};

export const saveProfile = (data) => {
  localStorage.setItem("TIMESHEET-PROFILE", JSON.stringify(data));
};

export const getProfile = () => {
  const data = JSON?.parse(localStorage.getItem("TIMESHEET-PROFILE"));
  return data;
};

export const clearAuth = () => {
  localStorage.removeItem("TIMESHEET-TOKEN");
  localStorage.removeItem("TIMESHEET-PROFILE");
};

// Capitalization
export const getCapitalization = (str) => {
  return str && str[0]?.toUpperCase() + str?.slice(1);
};

// // Date View Format
// export const pipViewDate = (date) => {
//   return moment(date).format("DD-MM-YYYY");
// };

// export const pipViewTime = (value) => {
//   return moment(value).format("hh:mm A")
// };